import MessageInput from './message-input';

import Icons from 'assets/icons';

export interface MessageInputNoticeProps {
  notice: string;
  placeholder?: string;
}

const noop = (): void => {};

const MessageInputNotice = ({
  notice,
  placeholder = 'Ask something',
}: MessageInputNoticeProps) => (
  <div className="w-full">
    <div
      role="status"
      className="flex items-center gap-2 rounded-t-lg bg-navy-50 px-3 border border-navy-100 pt-2.5 pb-[18px]"
    >
      <Icons.CellInfo aria-hidden customClass="size-4 shrink-0 text-navy-600" />
      <span className="text-sm leading-none text-navy-800">{notice}</span>
    </div>

    <MessageInput
      onSendMessage={noop}
      disabled
      placeholder={placeholder}
      customClass="-mt-2"
    />
  </div>
);

export default MessageInputNotice;
